module.exports = {
	"ha": "viha",
	"id": 5.6,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.6</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by PWID Status, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 99,
						"dataLabels": {
							"enabled": true,
							"format": "297"
						}
					},
					{
						"y": 88.33333333333333,
						"dataLabels": {
							"enabled": true,
							"format": "265"
						}
					},
					{
						"y": 84.33333333333334,
						"dataLabels": {
							"enabled": true,
							"format": "253"
						}
					},
					{
						"y": 76.33333333333333,
						"dataLabels": {
							"enabled": true,
							"format": "229"
						}
					},
					{
						"y": 55.333333333333336,
						"dataLabels": {
							"enabled": true,
							"format": "166"
						}
					},
					{
						"y": null
					},
					{
						"y": 98.3108108108108,
						"dataLabels": {
							"enabled": true,
							"format": "582"
						}
					},
					{
						"y": 92.0608108108108,
						"dataLabels": {
							"enabled": true,
							"format": "545"
						}
					},
					{
						"y": 87.16216216216216,
						"dataLabels": {
							"enabled": true,
							"format": "516"
						}
					},
					{
						"y": 82.60135135135135,
						"dataLabels": {
							"enabled": true,
							"format": "489"
						}
					},
					{
						"y": 65.03378378378379,
						"dataLabels": {
							"enabled": true,
							"format": "385"
						}
					},
					{
						"y": null
					},
					{
						"y": 90.95238095238095,
						"dataLabels": {
							"enabled": true,
							"format": "191"
						}
					},
					{
						"y": 70.47619047619048,
						"dataLabels": {
							"enabled": true,
							"format": "148"
						}
					},
					{
						"y": 67.14285714285714,
						"dataLabels": {
							"enabled": true,
							"format": "141"
						}
					},
					{
						"y": 61.904761904761905,
						"dataLabels": {
							"enabled": true,
							"format": "130"
						}
					},
					{
						"y": 46.666666666666664,
						"dataLabels": {
							"enabled": true,
							"format": "98"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -1.0000000000000009,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.77441077441077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.528301886792452,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.486166007905139,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.510917030567683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.6891891891891886,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.357388316151202,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.321100917431187,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.232558139534882,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.2678936605317,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -9.04761904761905,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.5130890052356,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.729729729729726,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.801418439716312,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.615384615384617,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "PWID<br>n=300"
			},
			{
				"x": 9,
				"text": "Non-PWID<br>n=592"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=210"
			}
		],
		"dataTable": {
			"IDU": [
				300,
				297,
				265,
				253,
				229,
				166
			],
			"Non-IDU": [
				592,
				582,
				545,
				516,
				489,
				385
			],
			"Unknown": [
				210,
				191,
				148,
				141,
				130,
				98
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_6.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_6.json
// module id = 340
// module chunks = 0